module.exports = __webpack_public_path__ + "img/logo.b793c2dd.png";